/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Self, Optional, ChangeDetectorRef } from '@angular/core';
import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { NgControl } from '@angular/forms';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';
import { ProcoreService, IProcoreRFI } from 'src/app/services/procore.service';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { LoadingBlockerState } from 'src/app/common/utility-components/loading-blocker';
import { TicketEditService } from '../../ticket-edit.service';
import { takeUntil, withLatestFrom, filter, switchMap } from 'rxjs/operators';
import { EditTicketsCombined } from 'src/app/app-data/models/EditTicketsCombined';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { DefaultLoggerService } from '@touchplan/logging';
import { RouteDataStateService } from 'src/app/services/route-data.state.service';

@Component({
	selector: 'ticket-procore-status',
	templateUrl: './ticket-procore-status.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [LoggerServiceFactory.provide('TicketProcoreStatusComponent')],
})
export class TicketProcoreStatusComponent extends TicketEditBaseComponent {
	public procoreRfi$: BehaviorSubject<IProcoreRFI> = new BehaviorSubject(null);
	public url: string;
	public rfiId: any;
	public loadingObservable: Subject<LoadingBlockerState> = new Subject();
	private etc: EditTicketsCombined;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef,
		private ticketEditService: TicketEditService,
		public procoreService: ProcoreService,
		private logger: DefaultLoggerService,
		private routeDataState: RouteDataStateService
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		this.procoreRfi$.subscribe((rfi: any) => {
			this.logger.log('RFI', rfi);
			if (rfi && rfi.link) {
				this.url = rfi.link;
				this.loadingObservable.next(LoadingBlockerState.complete);
			} else {
				this.loadingObservable.next(LoadingBlockerState.failure);
			}
		});

		// Subscribe to the current set of data
		this.ticketEditService.combinedEdit$
			.pipe(
				withLatestFrom(this.routeDataState.projectData$.pipe(filter((projectData) => !!projectData))),
				takeUntil(this.shutdownSubject),
				switchMap(([etc, activatedRouteProjectData]) => {
					this.etc = etc;
					if (etc) {
						this.rfiId = etc.data.procoreRfiId;
						if (this.rfiId) {
							return this.procoreService.getRFI(
								this.rfiId,
								activatedRouteProjectData.procoreProjectId,
								activatedRouteProjectData.procoreCompanyId
							);
						}
						return of(null);
					}
					return of(null);
				})
			)
			.subscribe(this.procoreRfi$);

		this.loadingObservable.next(LoadingBlockerState.inProgress);
	}

	public close(): void {
		this.ticketEditService.setOverlay(null);
	}

	public goToRFI(): void {
		window.open(this.url, '_blank');
	}

	public deleteLink(): void {
		this.ticketEditService.writeCombinationBackToList(this.etc, { procoreRfiId: null });
		this.internalField.setValue(null);
		this.ticketEditService.setOverlay(null);
	}
}
